// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Clickable from "@insite/mobius/Clickable";
import Link from "@insite/mobius/Link";
import OverflowMenu from "@insite/mobius/OverflowMenu";
import Typography from "@insite/mobius/Typography";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC, useState } from "react";
import { css } from "styled-components";

const wrapperCss = css`
    display: flex;
    align-items: center;
    column-gap: 40px;
`;

const contentCss = css`
    display: flex;
`;

const StyleguideOverflowMenus: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Overflow Menus" sectionId={sectionId}>
            <StyledWrapper css={wrapperCss}>
                <StyledWrapper css={contentCss}>
                    <Typography>Clickable:</Typography>
                    <OverflowMenu position="start">
                        <Clickable href="#">Lorem Ipsum</Clickable>
                        <Clickable href="#">Dolor Sit Amet</Clickable>
                        <Clickable href="#">Etiam facilisis ullamcorper semper suspendisse eget quam ut</Clickable>
                    </OverflowMenu>
                </StyledWrapper>
                <StyledWrapper css={contentCss}>
                    <Typography>Link:</Typography>
                    <OverflowMenu position="start">
                        <Link href="#">Lorem Ipsum</Link>
                        <Link href="#">Dolor Sit Amet</Link>
                        <Link href="#">Etiam facilisis ullamcorper semper suspendisse eget quam ut</Link>
                    </OverflowMenu>
                </StyledWrapper>
            </StyledWrapper>
        </StyleguideSection>
    );
};

export default StyleguideOverflowMenus;
